import React, { Component } from "react";
import { Formik } from "formik";
import { server } from "../../../constants";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
} from "shards-react";
import * as actions from "../../../actions/meeting.action";
import { connect } from "react-redux";
import { httpClient } from "../../../utils/HttpClient";
import Swal from "sweetalert2";
import moment from "moment";
import MeetingForm from "../MeetingForm";
import * as Yup from "yup";
import { Spin, Button, message } from 'antd';
import axios from 'axios'
import { apiUrl } from "../../../config/index";
import { LoadingOutlined } from '@ant-design/icons';
import { Packer } from "docx";
import { DocumentCreator } from "../invite-doc-generator";
import Autosuggest from "react-autosuggest";
import FileSaver from "file-saver";

const meetingValidationSchema = Yup.object().shape({
  title: Yup.string().required("กรุณาเลือกชื่อการประชุม"),
  location: Yup.string().required("กรุณาเลือกสถานที่การประชุม"),
  building: Yup.string().required("กรุณาเลือกอาคาร"),
  room: Yup.string().required("กรุณากรอกห้องประชุม"),
  sequence: Yup.string().required("กรุณากรอกครั้งที่ประชุม"),
  meetingDate: Yup.string().required("กรุณากรอกวันที่ประชุม").nullable(),
  meetingStart: Yup.string().required("กรุณากรอกเวลาเริ่มต้น").nullable(),
  meetingEnd: Yup.string().required("กรุณากรอกเวลาสิ้นสุด").nullable(),
});

class CreateMeeting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    }
  }

  createDocumentContent(meeting, fileName)  {
    //Set up meeting data
    const meetingDate = moment(meeting.meetingDate).locale('th').format('DD')
    const meetingMonth = moment(meeting.meetingDate).locale('th').format('MMMM')
    const meetingYear = parseInt(moment(meeting.meetingDate).locale('th').format('YYYY')) + 543
    const meetingTimeStart = moment(meeting.meetingStart).locale('th').format('HH:mm')
    const meetingTimeEnd = meeting.meetingEnd ? moment(meeting.meetingEnd).locale('th').format('HH:mm') : ''
    let roomName
    let buildingName
    let locationName

    if(this.props.roomsReducer.rooms)  {
      this.props.roomsReducer.rooms.map(item => {
        if(meeting.room == item.id)  {
          roomName = item.name
        }
      })
    }

    if(this.props.buildingsReducer.buildings)  {
      this.props.buildingsReducer.buildings.map(item => {
        if(meeting.building == item.id)  {
          buildingName = item.name
        }
      })
    }

    if(this.props.locationsReducer.locations)  {
      this.props.locationsReducer.locations.map(item => {
        if(meeting.location == item.id)  {
          locationName = item.name
        }
      })
    }
    
    const meetingDetail = {
      title: meeting.title,
      year: `ครั้งที่ ${meeting.sequence}/${meetingYear}`,
      date: `วันที่ ${meetingDate} ${meetingMonth} ${meetingYear} เวลา ${meetingTimeStart} ${meetingTimeEnd ? `- ${meetingTimeEnd} น.` : 'น.'}`,
      location: `ณ ${roomName} ${buildingName} ${locationName}`
    }

    let agendas = []

    meeting.agendas.map(item => {
      let body = item.body
      const bodyArray = body.split('\n')
      bodyArray.push('')

      agendas.push({
        title: item.title,
        body: bodyArray
      })
    })
    
    return this.generateFile(meetingDetail, agendas, fileName)
  }

  async generateFile(meeting, agendas, fileName) {
    const documentCreator = new DocumentCreator();

    const doc = documentCreator.create(meeting, agendas);
    const blob = await Packer.toBlob(doc)  
    // FileSaver.saveAs(blob, "hello world.docx");
    const file = new File([blob], `${fileName}.docx`, {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"});

    return file
  }

  showForm = ({
    values,
    handleChange,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    errors,
    touched,
  }) => {
    return (
      <div style={{ padding: 20 }}>
        <Card>
          <CardBody>
            <h5 className="font-weight-bold pb-3">เพิ่มการประชุม</h5>
            <Row>
              <Col>
                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <Spin 
                    spinning={this.state.loading}
                    indicator={<LoadingOutlined style={{ fontSize: 24, color: '#2a80b9' }} spin />}
                  >
                    <MeetingForm
                      values={values}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                    ></MeetingForm>
                  </Spin>

                  <div className="text-right mt-4 mb-2">
                    <Button
                      size="large"
                      type="primary"
                      htmlType="submit"
                      className="mr-3"
                      disabled={this.state.loading}
                      loading={this.state.loading}
                      style={{ minWidth: 150 }}
                    >
                      { this.state.loading ? 'กำลังบันทึกข้อมูลการประชุม' : 'เพิ่มการประชุม' }
                    </Button>
                    <Button
                      size="large"
                      onClick={() => {
                        this.props.history.goBack();
                      }}
                      htmlType="Button"
                      className="btn-secondary"
                      style={{ minWidth: 150 }}
                    >
                      ย้อนกลับ
                    </Button>
                  </div>
                </form>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <Formik
          initialValues={{
            title: "",
            location: "",
            building: "",
            room: "",
            sequence: "",
            meetingDate: new Date(),
            meetingStart: moment().format('YYYY-MM-DD 09:00:00'),
            meetingEnd: moment().format('YYYY-MM-DD 12:00:00'),
            agendas: [],
            createDocumentMethod: 1,
            attendeesMethod: 1,
            lastMeetingId: '',
            file: ''
          }}
          validationSchema={meetingValidationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            this.setState({loading: true})
            var result = localStorage.getItem("user_profile");
            const profile = JSON.parse(result);

            const locationName = this.props.locationsReducer.locations.filter((item) => {
              return item.id == values.location;
            })[0].name;
        
            const buildingName = this.props.buildingsReducer.buildings.filter((item) => {
              return item.id == values.building;
            })[0].name;
        
            const roomName = this.props.roomsReducer.rooms.filter((item) => {
              return item.id == values.room;
            })[0].name;

            const fullLocation = `${locationName} ${buildingName} ${roomName}`;

            const meetingDate = values.meetingDate.getDate()
            const meetingMonth = values.meetingDate.getMonth()
            const meetingYear = values.meetingDate.getFullYear()

            values.meetingStart = new Date(values.meetingStart)
            values.meetingEnd = new Date(values.meetingEnd)
            
            values.meetingStart.setDate(meetingDate)
            values.meetingStart.setMonth(meetingMonth)
            values.meetingStart.setFullYear(meetingYear)
            values.meetingEnd.setDate(meetingDate)
            values.meetingEnd.setMonth(meetingMonth)
            values.meetingEnd.setFullYear(meetingYear)
            
            const params = {
              title: values.title,
              location: values.location,
              building: values.building,
              room: values.room,
              sequence: values.sequence,
              year: parseInt(moment(values.meetingStart).locale('th').format('YYYY')),
              meetingStart: values.meetingStart,
              meetingEnd: values.meetingEnd,
              agendas: values.agendas.map(item => { return { ...item, createdBy: profile.displayName}}),
              fullLocation: fullLocation,
              createdBy: profile.id
            }

            if(values.createDocumentMethod === 1) {
              values.file = await this.createDocumentContent(values, `ระเบียบวาระ${values.title}`)
            }
            
            const token = localStorage.getItem("token");

            try {
              let response = await httpClient.post(server.MEETING_URL, JSON.stringify({
                meeting: params,
                lastMeetingId: values.lastMeetingId,
                attendeesMethod: values.attendeesMethod
              }), {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              });

              if (response.status === 201 || response.status === 200) {
                setSubmitting(false);

                let meeting = response.data
    
                if(values.file) {
                  let formData = new FormData();
                  formData.append('file', values.file);
                  
                  //ระเบียบวาระการประชุม
                  const inviteUploadResponse = await axios.request({
                    method: "post", 
                    url: `${apiUrl}/api/meetings/${meeting.id}/upload/file/${meeting.documentFolder}/1`,
                    data: formData, 
                    headers: {
                      Authorization: `Bearer ${token}`,
                    }
                  })
                }

                message.success('การประชุมถูกสร้างเรียบร้อยแล้ว');
                this.setState({loading: false})
                this.props.history.push(`/meeting/edit/${response.data.id}`);
              } else {
                message.success('เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
                this.setState({loading: false})
              }
            } catch(err)  {
              if(err.response.status === 409) {
                message.error(`${params.title} ครั้งที่ ${params.sequence}/${params.year + 543} ได้ถูกสร้างในระบบแล้ว ไม่สามารถสร้างการประชุมซ้ำได้`);
              } 
            }

            this.setState({loading: false})
          }}
        >
          {(props) => this.showForm(props)}
        </Formik>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  meetingReducer,
  buildingsReducer,
  locationsReducer,
  roomsReducer,
}) => ({ 
  meetingReducer,
  buildingsReducer,
  locationsReducer,
  roomsReducer,  
});

const mapDispatchToProps = {
  ...actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateMeeting);
